<template>
	<v-container
		class="fill-height"
		fluid>
		<v-row
			align="center"
			justify="center">
			<RegisterSuccess v-if="registerSucceeded">
			</RegisterSuccess>
      <v-col
				cols="12"
				sm="8"
				md="8"
				v-if="!registerSucceeded">
        <RegisterForm @registration-created="registerSucceeded = true">
        </RegisterForm>
      </v-col>
    </v-row>
  </v-container>
      
</template>

<script>
import RegisterForm from './RegisterForm'
import RegisterSuccess from './RegisterSuccess'

export default {
  name: 'Register',
  components: { RegisterForm, RegisterSuccess },
  data() {
    return {
      registerSucceeded: false
    }
  },
}
</script>